import { type ReactNode, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { GlowOrb } from '@/components/effects/glow-orb';
import { PrivacyPolicyContent } from './privacy-policy';
import { TermsContent } from './terms';

type LegalType = 'privacy' | 'terms';

const TITLES: Record<LegalType, string> = {
  privacy: 'Política de Privacidad',
  terms: 'Términos y Condiciones',
};

function BackLink(): ReactNode {
  return (
    <Link
      to="/"
      className="inline-flex items-center gap-xs text-xs text-text-tertiary hover:text-text-primary"
    >
      <ArrowLeft size={14} />
      Volver
    </Link>
  );
}

function EntityInfo(): ReactNode {
  return (
    <div className="space-y-1 text-xs leading-relaxed text-text-tertiary">
      <p>
        <span className="text-text-secondary">Entidad:</span> La divina comedia
        sa
      </p>
      <p>
        <span className="text-text-secondary">Domicilio:</span> Calle Ricardo J
        Alfaro, Edificio PH the century tower, oficina 317, Panamá (código
        postal 0830)
      </p>
      <p>
        <span className="text-text-secondary">Contacto:</span>{' '}
        support@debook.app
      </p>
      <p>
        <span className="text-text-secondary">Última actualización:</span> 30 de
        mayo de 2026
      </p>
    </div>
  );
}

function Header({ title }: { title: string }): ReactNode {
  return (
    <div className="space-y-sm">
      <BackLink />
      <h1 className="font-display text-xl font-bold tracking-tight text-text-primary sm:text-2xl">
        {title}
      </h1>
      <EntityInfo />
    </div>
  );
}

export function LegalPage({ type }: { type: LegalType }): ReactNode {
  const title = TITLES[type];
  useEffect(() => {
    document.title = `${title} | The 3333 Games`;
  }, [title]);
  return (
    <div className="relative min-h-dvh bg-void px-md py-xl sm:px-base">
      <GlowOrb />
      <div className="relative z-10 mx-auto w-full max-w-[640px] space-y-lg">
        <Header title={title} />
        {type === 'privacy' ? <PrivacyPolicyContent /> : <TermsContent />}
      </div>
    </div>
  );
}
